import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import {
  getFilteredRepositories,
  getOrgLevelRepos
} from './repositories-modal.service';
import OwnerRepositories from './OwnerRepositories';

const OrganizationsRepositoriesWrapper = styled.div`
  width: 100%;
`;

const RepositoriesModalContent = ({
  providerConfig,
  toggleRepositorySelection,
  isCheckboxDisabled,
  getNumOfSelectableRepos,
  setOpenedOwnerRepositories,
  setSelected,
  ownerRepositories,
  openedOwnerRepositories,
  selected,
  stateRepositories,
  term,
  isOnboarding,
  multipleNew,
  azureOrganizationName = null
}) => {
  const numOfReposWithOwnerType = stateRepositories.filter(r =>
    _.get(r, 'owner_type', null)
  ).length;

  const groupedByComponents = Object.keys(ownerRepositories).map(owner => {
    const newRepositories = ownerRepositories[owner].filter(
      ({ isNew }) => isNew
    );
    return (
      <OwnerRepositories
        providerConfig={providerConfig}
        ownerName={azureOrganizationName || owner}
        key={owner}
        isOpen={openedOwnerRepositories === owner}
        setIsOpen={() =>
          openedOwnerRepositories === owner
            ? setOpenedOwnerRepositories('')
            : setOpenedOwnerRepositories(owner)
        }
        repositories={
          isOnboarding
            ? getOrgLevelRepos(
                getFilteredRepositories(ownerRepositories[owner], term)
              )
            : getFilteredRepositories(ownerRepositories[owner], term)
        }
        newRepositories={newRepositories}
        isOnboarding={isOnboarding}
        numOfSelectableRepos={getNumOfSelectableRepos() - selected.size}
        numOfReposWithOwnerType={numOfReposWithOwnerType}
        setSelected={setSelected}
        selected={selected}
        toggleRepositorySelection={toggleRepositorySelection}
        isCheckboxDisabled={isCheckboxDisabled}
        showCreatedOnHeader={multipleNew && newRepositories.length}
      />
    );
  });

  return (
    <OrganizationsRepositoriesWrapper>
      {groupedByComponents}
    </OrganizationsRepositoriesWrapper>
  );
};

export default RepositoriesModalContent;
